import { Component, Inject, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Observable } from 'rxjs';
import { PortalStateService, PortalState } from '../../services/portal-state.service';

@Component({
  selector: 'app-feature-container',
  templateUrl: './feature-container.component.html',
  styleUrls: ['./feature-container.component.scss'],
  standalone: false
})
export class FeatureContainerComponent implements OnInit {
  portalState$: Observable<PortalState>;

  constructor(
    private portalStateService: PortalStateService,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.portalState$ = this.portalStateService.getCurrentState();
  }

  ngOnInit(): void {
    this.appendHashToUrl();
  }

  // Display-only: marks the new layout's URL with a trailing '/#' (e.g. /temenos/#).
  private appendHashToUrl(): void {
    const { href, pathname, search } = this.document.location;
    const history = this.document.defaultView?.history;
    if (history && !href.includes('#')) {
      const path = pathname.endsWith('/') ? pathname : `${pathname}/`;
      history.replaceState(history.state, '', `${path}${search}#`);
    }
  }
}
